/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * Paginated list of companies.
 * @export
 * @interface ListCompaniesResponse
 */
export interface ListCompaniesResponse {
    /**
     * 
     * @type {Array<Company>}
     * @memberof ListCompaniesResponse
     */
    items: Array<Company>;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the ListCompaniesResponse interface.
 */
export function instanceOfListCompaniesResponse(value: object): value is ListCompaniesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function ListCompaniesResponseFromJSON(json: any): ListCompaniesResponse {
    return ListCompaniesResponseFromJSONTyped(json, false);
}

export function ListCompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompaniesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CompanyFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function ListCompaniesResponseToJSON(json: any): ListCompaniesResponse {
    return ListCompaniesResponseToJSONTyped(json, false);
}

export function ListCompaniesResponseToJSONTyped(value?: ListCompaniesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CompanyToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

